'use strict';
const angular = require('angular');

/*@ngInject*/
export function ViewSelectionService() {

  //TODO: Add accounting period selection here
  
  var view = {
    selectedCommunityCode: "",
    selectedCommunity: {}
  };

  return view;
}


export default angular.module('conduuApp.viewSelection', [])
  .factory('ViewSelection', ViewSelectionService)
  .name;



// WEBPACK FOOTER //
// ./client/components/view-selection/view-selection.service.js